const SOFT_HYPHEN_POS = 8;

export const softHyphenate = (input: string) => {
  const words = input.split(/(\s+)/);
  words.forEach((word, index) => {
    if (word.length > SOFT_HYPHEN_POS && word.match(/^[a-zA-Z]+$/)) {
      // Give go.js the option to break long, alphabetic-only words in half
      // (or at SOFT_HYPHEN_POS; whichever comes first)
      const breakPos = Math.min(SOFT_HYPHEN_POS, Math.floor(word.length / 2));
      words[index] = `${word.slice(0, breakPos)}\u00AD${word.slice(breakPos)}`;
    }
  });
  return words.join('');
};
